import classNames from "classnames";
import { FieldState } from "formstate";
import { observer } from "mobx-react";
import React, { useState } from "react";
import { AgentInput } from "@fidget/common/components/form/agentInput";
import {
  AutoCompleteProps,
  AutoComplete
} from "@fidget/common/components/form/autoComplete/autoComplete";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { caseInsensitiveIncludes } from "@fidget/common/utils/searchMatching";
import { useStore } from "../../../models";
import { ITagGroup } from "../../../models/tagGroups/TagGroupStore";
import settingsStyles from "../../../styles/settings.css";

interface Props extends Omit<Partial<AutoCompleteProps<ITagGroup>>, "onChange"> {
  onChange(tag: ITagGroup): void;
  tagGroupId?: string;
  /** Set tag groupss suggested in autocomplete, if ommited will default to groups from TagGroupsStore */
  values?: ITagGroup[];
}

export const TagGroupPicker = observer(
  ({ values, onChange, tagGroupId, className, ...autoCompleteProps }: Props) => {
    const { tagGroupsStore } = useStore();
    const [inputField] = useState(new FieldState(""));

    const tagGroups = values || tagGroupsStore.groups;
    const value = tagGroupId ? tagGroupsStore.getById(tagGroupId) : undefined;

    const handleChange = (val: ITagGroup | "") => {
      if (val) {
        onChange(val);
      }
    };

    return (
      <AutoComplete<ITagGroup>
        className={classNames(settingsStyles["input-max-width-bigger"], className)}
        onChange={handleChange}
        itemsProvider={
          inputField.$
            ? () => tagGroups.filter((tag) => caseInsensitiveIncludes(tag.name, inputField.$))
            : () => tagGroups
        }
        itemToString={(val) => val?.name || ""}
        placeholder={intl.formatMessage("tagGroupPicker.placeholder")}
        readOnly
        inputValue={value ? value.name : ""}
        emptyPlaceholder={intl.formatMessage("tagGroupPicker.empty")}
        {...autoCompleteProps}
      >
        <AgentInput
          field={inputField}
          placeholder={intl.formatMessage("tagGroupPicker.input.placeholder")}
        />
      </AutoComplete>
    );
  }
);
